(function () {
  'use strict';
  window.okhomesMapNews = function (root, renderCard) {
    if (root.dataset.newsReady) return;
    var source = document.getElementById(root.id.replace('okhomes-home-map-', 'okhomes-news-data-'));
    if (!source) return;
    var data;
    try { data = JSON.parse(source.textContent); } catch (_) { return; }
    root.dataset.newsReady = 'true';
    var stage = root.querySelector('.okhomes-home-map__stage');
    var panel = document.createElement('aside');
    panel.className = 'okhomes-map-news';
    panel.hidden = true;
    panel.setAttribute('aria-label', data.labels.heading);
    var heading = document.createElement('div');
    heading.className = 'okhomes-map-news__heading';
    var title = document.createElement('span');
    title.textContent = data.labels.heading;
    function button(label, text) {
      var node = document.createElement('button');
      node.type = 'button';
      node.setAttribute('aria-label', label);
      node.textContent = text;
      return node;
    }
    var close = button(data.labels.close, '×');
    heading.append(title, close);
    var content = document.createElement('div');
    var controls = document.createElement('div');
    controls.className = 'okhomes-map-news__controls';
    var previous = button(data.labels.previous, '‹');
    var next = button(data.labels.next, '›');
    var pause = button(data.labels.pause, 'Ⅱ');
    var count = document.createElement('span');
    count.className = 'okhomes-map-news__count';
    controls.append(previous, count, pause, next);
    panel.append(heading, content, controls);
    var reopen = button(data.labels.heading, data.labels.heading);
    reopen.className = 'okhomes-map-news__reopen';
    reopen.hidden = true;
    stage.append(panel, reopen);
    var items = [], current = null, index = 0, timer, transition, expiry;
    var closed = false, paused = matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hovered = false, focused = false, visible = true, disposed = false;
    var seenPages = new Set();
    function now() { return Date.now() / 1000; }
    function eligible(p, time) { return p.published > 0 && p.published <= time && time < p.published + 604800; }
    function clearRotation() { clearTimeout(timer); clearTimeout(transition); }
    function schedule() {
      clearTimeout(timer);
      if (!disposed && !closed && !paused && !hovered && !focused && visible && !document.hidden && items.length) {
        timer = setTimeout(function () { change(1); }, 8000);
      }
    }
    function updatePause() {
      pause.textContent = paused ? '▶' : 'Ⅱ';
      pause.setAttribute('aria-label', paused ? data.labels.play : data.labels.pause);
    }
    function show() {
      if (!items.length || disposed) return;
      current = items[index];
      panel.classList.remove('is-leaving');
      content.innerHTML = '<div class="okhomes-map-news__desktop">' + renderCard([current]) + '</div>';
      var mobile = document.createElement('a');
      mobile.className = 'okhomes-map-news__mobile';
      mobile.href = current.url;
      if (current.image) {
        var photo = document.createElement('img');
        photo.className = 'okhomes-map-news__photo';
        photo.src = current.image;
        photo.alt = '';
        photo.loading = 'lazy';
        mobile.append(photo);
      }
      var location = document.createElement('span');
      var place = [current.locality, current.province].filter(Boolean).join(' · ');
      if (!place) {
        place = String(current.title || '').split(/\s+-\s+/).find(function (part) {
          return part.trim() && !/^(?:(?:casa(?:\s+r[úu]stica)?|piso|chalet|villa|apartamento|d[úu]plex|pazo|negocio|local(?:\s+comercial)?|terreno|finca|garaje|solar|estudio|[áa]tico)(?:\s+(?:v|venta|alquiler))?|v|venta|alquiler(?:\s+con\s+opci[óo]n\s+a\s+compra)?)$/i.test(part.trim()) && !/^(?:ref|aa\/|\d)/i.test(part.trim());
        }) || '';
      }
      location.textContent = place;
      var price = document.createElement('strong');
      var renderedPrice = content.querySelector('.okhomes-popup-price');
      price.textContent = renderedPrice ? renderedPrice.textContent : current.price;
      mobile.append(location, price);
      content.append(mobile);
      count.textContent = (index + 1) + ' / ' + items.length;
      previous.disabled = next.disabled = items.length < 2;
      panel.hidden = closed;
      reopen.hidden = !closed;
      panel.classList.remove('is-entering');
      void panel.offsetWidth;
      panel.classList.add('is-entering');
      schedule();
    }
    function refresh() {
      clearTimeout(expiry);
      var time = now(), old = current && current.url;
      items = items.filter(function (p) { return eligible(p, time); });
      index = Math.max(0, items.findIndex(function (p) { return p.url === old; }));
      if (!items.length) {
        clearRotation();
        panel.hidden = reopen.hidden = true;
        current = null;
        return;
      }
      var remaining = Math.min.apply(null, items.map(function (p) { return p.published + 604800 - time; }));
      expiry = setTimeout(refresh, Math.max(1, remaining * 1000));
      if (!current || current.url !== items[index].url) show();
      else { count.textContent = (index + 1) + ' / ' + items.length; previous.disabled = next.disabled = items.length < 2; schedule(); }
    }
    function change(direction) {
      clearRotation();
      refresh();
      if (!items.length) return;
      panel.classList.remove('is-entering');
      panel.classList.add('is-leaving');
      transition = setTimeout(function () {
        index = (index + direction + items.length) % items.length;
        show();
      }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 260);
    }
    function add(list) {
      var known = new Set(items.map(function (p) { return p.url; }));
      list.forEach(function (p) { if (!known.has(p.url) && eligible(p, now())) { items.push(p); known.add(p.url); } });
      items.sort(function (a, b) { return b.published - a.published; });
      refresh();
    }
    previous.addEventListener('click', function () { change(-1); });
    next.addEventListener('click', function () { change(1); });
    pause.addEventListener('click', function () { paused = !paused; updatePause(); schedule(); });
    close.addEventListener('click', function () { closed = true; clearRotation(); panel.hidden = true; reopen.hidden = !items.length; reopen.focus(); });
    reopen.addEventListener('click', function () { closed = false; refresh(); if (items.length) { show(); close.focus(); } });
    panel.addEventListener('pointerenter', function (event) { if (event.pointerType === 'mouse') { hovered = true; clearRotation(); } });
    panel.addEventListener('pointerleave', function () { hovered = false; schedule(); });
    panel.addEventListener('focusin', function () { focused = true; clearRotation(); });
    panel.addEventListener('focusout', function (event) { focused = panel.contains(event.relatedTarget); schedule(); });
    panel.addEventListener('pointerdown', function (event) { if (event.pointerType === 'touch' && content.contains(event.target)) { paused = true; updatePause(); clearRotation(); } });
    function visibility() { if (document.hidden) clearRotation(); else { refresh(); schedule(); } }
    document.addEventListener('visibilitychange', visibility);
    var observer = new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; if (visible) schedule(); else clearRotation(); });
    observer.observe(stage);
    var resize = new ResizeObserver(function () { panel.style.setProperty('--okhomes-news-room', Math.max(100, stage.clientHeight - 300) + 'px'); });
    resize.observe(stage);
    function restore(event) { if (event.persisted) { refresh(); schedule(); } }
    window.addEventListener('pageshow', restore);
    function dispose(event) {
      if (event.type === 'pagehide' && event.persisted) { clearRotation(); clearTimeout(expiry); return; }
      if (event.type === 'shopify:section:unload' && !event.target.contains(root)) return;
      disposed = true; clearRotation(); clearTimeout(expiry); observer.disconnect(); resize.disconnect();
      document.removeEventListener('visibilitychange', visibility);
      document.removeEventListener('shopify:section:unload', dispose);
      window.removeEventListener('pagehide', dispose);
      window.removeEventListener('pageshow', restore);
    }
    document.addEventListener('shopify:section:unload', dispose);
    window.addEventListener('pagehide', dispose);
    updatePause();
    add(data.properties || []);
    function loadMore(path) {
      if (!path || disposed || seenPages.has(path)) return;
      seenPages.add(path);
      var url = new URL(path, location.origin);
      url.searchParams.set('section_id', root.id.replace('okhomes-home-map-', ''));
      fetch(url, { credentials: 'same-origin' }).then(function (response) { if (!response.ok) throw Error('news'); return response.text(); }).then(function (html) {
        if (disposed) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var node = doc.querySelector('[data-okhomes-map-news-data]');
        if (!node) return;
        var page = JSON.parse(node.textContent);
        add(page.properties || []);
        loadMore(page.next);
      }).catch(function () {});
    }
    loadMore(data.next);
  };
})();
